const GetApplicationsUrl = (id: number) => `/admin/api/temp_workers/${id}/applications`;

export { GetApplicationsUrl };
